import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = () => (
  <Helmet>
    <title>QuickCruit - Your Fastest Path to a Job</title>
    <meta name="description" content="Elevate Your Resume and Cover Letter with AI Precision. QuickCruit transforms your applications to stand out to recruiters and effortlessly pass ATS filters." />
    <meta name="keywords" content="job search, AI resume builder, job matching, QuickCruit, career services, resume tailoring, cover letter, ATS optimization" />
    <meta name="author" content="QuickCruit" />
    
    {/* Comprehensive SEO Structured Data for Logo, Sitelinks & Rich Snippets */}
    <script type="application/ld+json">
      {`
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "QuickCruit",
          "alternateName": "QuickCruit.ai",
          "description": "Elevate Your Resume and Cover Letter with AI Precision. QuickCruit transforms your applications to stand out to recruiters and effortlessly pass ATS filters.",
          "url": "https://www.quickcruit.ai",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.quickcruit.ai/logo.png",
            "width": "512",
            "height": "512"
          },
          "image": "https://www.quickcruit.ai/og-image.png",
          "sameAs": [
            "https://www.linkedin.com/company/quickcruit",
            "https://www.instagram.com/quickcruit.ai",
            "https://twitter.com/quickcruit"
          ],
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "Customer Service",
            "url": "https://www.quickcruit.ai/contact-us",
            "availableLanguage": ["English"]
          },
          "founder": {
            "@type": "Person",
            "name": "Nilay Patel",
            "url": "https://www.linkedin.com/in/nilay-p-quickcruit"
          },
          "foundingDate": "2024",
          "knowsAbout": [
            "Resume Writing",
            "Cover Letter Writing", 
            "Job Search",
            "ATS Optimization",
            "Career Development",
            "AI-Powered Resume Tools",
            "Job Application Assistance"
          ],
          "serviceType": [
            "Resume Tailoring",
            "Cover Letter Generation", 
            "Job Matching",
            "Career Services"
          ],
          "areaServed": "Worldwide",
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "QuickCruit Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "AI Resume Tailoring",
                  "description": "AI-powered resume optimization for specific job applications",
                  "url": "https://www.quickcruit.ai/features/resume-tailoring"
                }
              },
              {
                "@type": "Offer", 
                "itemOffered": {
                  "@type": "Service",
                  "name": "AI Cover Letter Generation",
                  "description": "Personalized cover letters generated with AI precision",
                  "url": "https://www.quickcruit.ai/features/cover-letter"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service", 
                  "name": "Job Search Platform",
                  "description": "Curated job listings with AI-powered matching",
                  "url": "https://www.quickcruit.ai/jobs"
                }
              }
            ]
          },
          "potentialAction": {
            "@type": "SearchAction",
            "target": {
              "@type": "EntryPoint", 
              "urlTemplate": "https://www.quickcruit.ai/jobs?q={search_term_string}"
            },
            "query-input": "required name=search_term_string"
          }
        }
      `}
    </script>
  </Helmet>
);

export default SEO;
